import * as React from 'react';
export const SvgFiletypeVisio = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', ...props },
        React.createElement("path", { d: 'M11 3V0H2v16h12V3z', fill: '#37539d' }),
        React.createElement("path", { d: 'M7.304 10L5.27 4h1.284l1.129 3.57q.094.317.195.737t.125.585a10.704 10.704 0 01.307-1.321L9.446 4h1.286l-2.04 6zm3.696.586l-.914.914H6V11H4v2h2v-.5h4.086l.914.914L12.414 12z', fill: '#fff' }),
        React.createElement("path", { d: 'M11 3V0l3 3z', fill: '#263a6e' })));
};
export default SvgFiletypeVisio;
